module.exports = __webpack_public_path__ + "e68110380775c95b6470001459cf1a67.svg";